import { useCallback, useState } from 'react';

import { Button } from '~components/generic/editor/Button/Button';
import { PenIcon } from '~components/icons/PenIcon';
import { SaveIcon } from '~components/icons/SaveIcon';
import styles from './EditComponents.module.css';

export const ButtonSection = () => {
  const [hasLabel, setHasLabel] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [hasIcon, setHasIcon] = useState(false);
  const [hasPreIcon, setHasPreIcon] = useState(false);
  const [isUnflashy, setIsUnflashy] = useState(false);

  const handleButtonClick = useCallback(e => {
    console.log('Button clicked', e);
  }, []);

  return (
    <div className={styles.container}>
      <section>
        <h5>Button</h5>
        <div className={styles.component}>
          <Button
            label={hasLabel ? 'Click me' : undefined}
            disabled={isDisabled}
            processing={isProcessing}
            icon={hasIcon ? <SaveIcon /> : undefined}
            preIcon={hasPreIcon ? <PenIcon /> : undefined}
            onClick={handleButtonClick}
            unflashy={isUnflashy}
          />
          <form>
            <label htmlFor="interactiveButtonHasLabel">Label: </label>
            <input
              type="checkbox"
              id="interactiveButtonHasLabel"
              checked={hasLabel}
              onChange={() => setHasLabel(!hasLabel)}
            />
            <br />
            <label htmlFor="interactiveButtonIsDisabled">Disabled: </label>
            <input
              type="checkbox"
              id="interactiveButtonIsDisabled"
              checked={isDisabled}
              onChange={() => setIsDisabled(!isDisabled)}
            />
            <br />
            <label htmlFor="interactiveButtonIsProcessing">Processing: </label>
            <input
              type="checkbox"
              id="interactiveButtonIsProcessing"
              checked={isProcessing}
              onChange={() => setIsProcessing(!isProcessing)}
            />
            <br />
            <label htmlFor="interactiveButtonHasIcon">Icon: </label>
            <input
              type="checkbox"
              id="interactiveButtonHasIcon"
              checked={hasIcon}
              onChange={() => setHasIcon(!hasIcon)}
            />
            <br />
            <label htmlFor="interactiveButtonHasPreIcon">PreIcon: </label>
            <input
              type="checkbox"
              id="interactiveButtonHasPreIcon"
              checked={hasPreIcon}
              onChange={() => setHasPreIcon(!hasPreIcon)}
            />
            <br />
            <label htmlFor="interactiveButtonIsUnflashy">Unflashy: </label>
            <input
              type="checkbox"
              id="interactiveButtonIsUnflashy"
              checked={isUnflashy}
              onChange={() => setIsUnflashy(!isUnflashy)}
            />
          </form>
        </div>
        <h6>All possible button states</h6>
        <div className={styles.component}>
          <Button label="Click me" _forceIdleState />
          <span> </span>
          <Button label="Click me" _forceHoverState />
          <span> </span>
          <Button label="Click me" _forceActiveState />
          <span> </span>
          <Button label="Click me" _forceDisabledState />
          <span> </span>
          <Button label="Click me" _forceProcessingState />
        </div>
        <div className={styles.component}>
          <Button label="Click me" icon={<PenIcon />} _forceIdleState />
          <span> </span>
          <Button label="Click me" icon={<PenIcon />} _forceHoverState />
          <span> </span>
          <Button label="Click me" icon={<PenIcon />} _forceActiveState />
          <span> </span>
          <Button label="Click me" icon={<PenIcon />} _forceDisabledState />
          <span> </span>
          <Button label="Click me" icon={<PenIcon />} _forceProcessingState />
        </div>
        <div className={styles.component}>
          <Button label="Click me" preIcon={<PenIcon />} _forceIdleState />
          <span> </span>
          <Button label="Click me" preIcon={<PenIcon />} _forceHoverState />
          <span> </span>
          <Button label="Click me" preIcon={<PenIcon />} _forceActiveState />
          <span> </span>
          <Button label="Click me" preIcon={<PenIcon />} _forceDisabledState />
          <span> </span>
          <Button label="Click me" preIcon={<PenIcon />} _forceProcessingState />
        </div>
        <div className={styles.component}>
          <Button icon={<PenIcon />} _forceIdleState />
          <span> </span>
          <Button icon={<PenIcon />} _forceHoverState />
          <span> </span>
          <Button icon={<PenIcon />} _forceActiveState />
          <span> </span>
          <Button icon={<PenIcon />} _forceDisabledState />
          <span> </span>
          <Button icon={<PenIcon />} _forceProcessingState />
        </div>
        <div className={styles.component}>
          <Button icon={<PenIcon />} _forceIdleState size="small" />
          <span> </span>
          <Button icon={<PenIcon />} _forceHoverState size="small" />
          <span> </span>
          <Button icon={<PenIcon />} _forceActiveState size="small" />
          <span> </span>
          <Button icon={<PenIcon />} _forceDisabledState size="small" />
          <span> </span>
          <Button icon={<PenIcon />} _forceProcessingState size="small" />
        </div>
        <div className={styles.component}>
          <Button label="Click me" icon={<PenIcon />} _forceIdleState size="small" />
          <span> </span>
          <Button label="Click me" icon={<PenIcon />} _forceHoverState size="small" />
          <span> </span>
          <Button label="Click me" icon={<PenIcon />} _forceActiveState size="small" />
          <span> </span>
          <Button label="Click me" icon={<PenIcon />} _forceDisabledState size="small" />
          <span> </span>
          <Button label="Click me" icon={<PenIcon />} _forceProcessingState size="small" />
        </div>
      </section>
    </div>
  );
};
